import { notification } from "antd";

export const showSuccessNotification = (message, description) => {
    const desc = description;
    notification.open({
        key: new Date().getTime(),
        message,
        description: desc,
        duration: 2,
        placement: "topRight",
        zIndex: 9999,
        style: { borderRadius: "10px", backgroundColor: "#EEFFF3", },
    });
};

export const showErrorNotification = (message, description) => {
    const desc = description;
    notification.open({
        key: new Date().getTime(),
        message,
        description: desc,
        duration: 5,
        placement: "topRight",
        zIndex: 9999,
        style: { borderRadius: "10px", backgroundColor: "#FFF5F6", },
    });
};